<template>
  <h3>{{mainTitle}}<small>{{subheading}}</small></h3>
</template>

<script>
export default {
  name: 'text-title',
  props: {
    mainTitle: String,
    subheading: String
  }
}
</script>

<style scoped>
h3 {
  text-align: left;
  font-size: 20px;
  color: #333;
  padding-top: 2px;
  padding-left: 10px;
  border-left: 5px solid #1362FF;
  margin: 20px 0 10px 0;
  font-weight: 400;
}
small {
  font-size: 14px;
  color: #97a8be;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Text/TextTitle.vue